import { lt, gt, isNull } from 'lodash';
import { COMMON_ERRORS } from '_constants/errors';
import { hasFalsyValue } from '..';
/**
 * Validate input text object and returns error string
 * @param  {string} {value
 * @param  {string} name
 * @param  {number} min=null
 * @param  {number} max=null
 * @param  {boolean} required=false}
 *
 * @returns {string} error | ''
 */
export default ({ value, name, min = null, max = null, required = false }) => {
  let error =
    (hasFalsyValue(value) && COMMON_ERRORS.isRequired(name)) ||
    (!isNull(min) && lt(value.length, min) && COMMON_ERRORS.lessThan(name, min)) ||
    (!isNull(max) && gt(value.length, max) && COMMON_ERRORS.moreThan(name, max));
  error = !required && hasFalsyValue(value) ? null : error;
  if (name === 'atcc') {
    if (!value) return false;
    const year = parseInt(value, 10);
    const currentYear = new Date().getFullYear();
    if (!/^\d{4}$/.test(value)) {
      return `Please enter a 4-digit year (e.g. ${currentYear})`;
    }
    if (year <= 2000) {
      return 'Year must be greater than 2000';
    }
    if (year > currentYear) {
      return `Year cannot be later than ${currentYear}`;
    }
  }
  return error;
};
